import React, { useState, useRef } from 'react';

import * as turf from '@turf/turf';

import {
    Alert,
    Card,
    Input,
    Checkbox,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
    Typography,
    IconButton,
    Radio,
    Tab,
    Tabs,
    TabsBody,
    TabsHeader,
    TabPanel,
    Tooltip,
    Select,
    Option,
    Textarea,

} from "@material-tailwind/react";
//import Select from 'react-select';

import {
    TruckIcon,
    TrashIcon,
    BeakerIcon,
    ChatBubbleLeftIcon,
    EnvelopeIcon,
    FingerPrintIcon,
    ChevronDoubleUpIcon,
    ChevronDoubleDownIcon,
    StopIcon,
    SquaresPlusIcon,
    Squares2X2Icon,
    XMarkIcon

} from "@heroicons/react/24/outline";


import { getFields } from './AdminTools.jsx';
import { showAlert } from './Alert.jsx';


import FieldsCheckList from './FieldsCheckList;.jsx';
import OrderHistoryList from './OrderHistoryCard.jsx';
import { getField } from './AdminTools.jsx';

export const COMPLETIONS =[{id:0, text: "Jeszcze nie pobrano próbek"},
                    {id:1, text: "Pobrano część próbek"},
                    {id:2, text: "Zakończono pobieranie próbek"},
  ]

const emptyGeoJson = {
  type: "FeatureCollection",
  features: []
}



export function FieldCompletionCard(props) {

    const [featureCollection, setFeatureCollection] = useState(JSON.parse(localStorage.getItem("featureCollection")) || emptyGeoJson);
    const [fields, setFields] = useState(props.fields || []);
    const [order, setOrder] = useState(props.order || []);
    const [fieldid, setFieldId] = useState(props.fieldid || 0);
    const [field, setField] = useState({});
    const [fieldName, setFieldName] = useState("");
    const [completionList, setCompletionList] = useState([])

    const [rank] = useState(localStorage.getItem("rank") || 0);
    const [userid] = useState(localStorage.getItem("userid") || 0);
    const [username] = useState(localStorage.getItem("username"));

    const [session, setSession] = useState(localStorage.getItem("session") || null);
    const [action, setAction] = useState('updateprop');



    const [parameters, setParameters] = useState({
        finalValue: 0,
        jobNumber:"",
        fieldMark:"",
        probesCount:0
    });






    React.useEffect(() => {
        
        var comp=JSON.parse(order.properties);
        getField(session,collectField,order.ownerid,fieldid);

        if (comp.completion) setCompletionList(comp.completion);
        
        

    }, []);

    React.useEffect(() => {
        console.log("field effect");
        console.log(field);
        setFieldName(field.name);
    }, [field]);


    function collectField(data)
    {
        if (data.length==1) setField(data[0]);
    }


    function selectFieldsToProbe() //and show on map
    {
        var _fieldsToProbe;
        _fieldsToProbe = clientFields.filter(cf=>cf.selected==true);
        
        setFieldsToProbe(_fieldsToProbe); //może byc niepotrzebne
        buildFeatureCollection(_fieldsToProbe);

    }




    function getFieldArea(fid) {
        let field = fields.filter(f => f.id == fid)[0];
        if (field) { return field.area; }
        else { return 0; }
    }


    function cancelClose() {
        //showGeoJson(featureCollection,false);
        props.Close(false);
    }




    function handleQuietResponse(data) {
        if (data.status === "ok") {
            console.log(data)
        }
        if (data.status !== "ok") {
            showAlert("red", data.message, 4000);
        }
    }



    function wasChanged(nowy,stary,opis)
    {
        
        var result=null;
        if ((!nowy) && (!stary)) return result;
        if (nowy!=stary)
        {
            result=opis + " (";
            if (stary) result+=stary.toString();
            else result+="undef";
            result+="->";
            if (nowy) result+=nowy.toString();
            else result+="undef";
            result+=")";
        }
        return result;
    }

    function wasChangedFields(nowy,stary,opis)
    {
        var result=null;
        if ((!nowy) && (!stary)) return result;

        
        if ((nowy.length === stary.length) && (nowy.slice().sort().every(function(value, index) { return value === stary[index];  })))    
        { }
        else
        {
            result=opis + " (";
            if (stary) result+=stary.toString();
            else result+="undef";
            result+="->";
            if (nowy) result+=nowy.toString();
            else result+="undef";
            result+=")";
        }
        return result;
    }

    function onChangeCompletion(fieldid,completion)
        {
            console.log("on Change");
            console.log("cL");
            console.log(completionList);
            if (completionList)
            {
                var compList=completionList.filter(c=>c.id!==fieldid);
                compList.push({id:fieldid, completion: completion});
                setCompletionList(compList);
                rebuildFeatureCollection(compList);
            }
            else
            {
                setCompletionList([{id:fieldid, completion: completion}]); //first entry
            }
    
            //selectFieldsToProbe();
            
        }




  function rebuildFeatureCollection(compList) {

    let newfc = {
      type: "FeatureCollection",
      features: []
    }
    console.log("featureCollection");
    console.log(featureCollection);
    featureCollection.features.forEach(feature => {
        var prop= feature.properties;
        var comp=compList.filter(c=>c.id==prop.fieldid)[0];
        var value=5;
        if (comp && (comp.completion==1)) value=4; 
        if (comp && (comp.completion==2)) value=1; 
        prop.value = value;
        newfc.features.push(feature);
        });

    console.log("newfc");
    console.log(newfc);
    
    showGeoJson(newfc, false);
  }




  function buildFeatureCollection(fields) {
    let newfc = {
      type: "FeatureCollection",
      features: []
    }


    fields.forEach(field => {
      let fieldshape = JSON.parse(field.shape);
      if (field.selected == true) {
        var comp=completionList.filter(c=>c.id==field.id)[0];
        var value=5;
        if (comp && (comp.completion==1)) value=4; 
        if (comp && (comp.completion==2)) value=1; 
        fieldshape.features.forEach(feature => {
          //feature.properties.value=1;  
          
          feature.properties.fieldid = field.id;
          feature.properties.value = value;
          //feature.properties.value = getExamValue(feature.examtime); //feature.examined
          feature.properties.polygonName=field.name; //feature.examined
          newfc.features.push(feature);
        });
      }
    });
    showGeoJson(newfc, false);
  }


function showGeoJson(features, refresh) {
    if (!features) return;

    let bounds = turf.bbox(features);
    let resizedbounds = resizeBoundingBox(bounds);

    applyFeatureCollection(features);
    applyBoundingBox(resizedbounds);
  }


  function resizeBoundingBox(bounds) {
    var point1 = turf.point([bounds[0], bounds[1]]);
    var point2 = turf.point([bounds[2], bounds[3]]);
    var bearing = turf.bearing(point1, point2);
    var distance = turf.distance(point1, point2);
    var p1 = turf.destination(point1, -0.2 * distance, bearing);
    var p2 = turf.destination(point2, 0.2 * distance, bearing);
    var box = [p1.geometry.coordinates[0], p1.geometry.coordinates[1], p2.geometry.coordinates[0], p2.geometry.coordinates[1]];
    return box;
  }


  function applyFeatureCollection(collection) {
    localStorage.setItem('featureCollection', JSON.stringify(collection));
    dispatchEvent(new Event("featureCollectionChanged"));
  }


  function applyBoundingBox(bounds) {
    localStorage.setItem('boundingBox', JSON.stringify(bounds));
    dispatchEvent(new CustomEvent('boundingBoxChanged', { detail: bounds })); 
  }


  function startTrackingOrder()
  {
   dispatchEvent(new CustomEvent('trackOrder', { detail: { order: order } })); 
  }





    function buildHistoryEntry(selected)
    {
        var changes=[];
        var nowy,stary;
        var change=null;
        var properties=order.properties;

        //////////////////////////////////////
        /////////////////////////////////

        


        var date = new Date();
        const options = { year: "numeric", month: "long", day: "numeric",};

        var datestr = date.toLocaleDateString("pl-PL",options) + " " + date.toLocaleTimeString();
        var entry = { user : username, date: datestr, changes:changes };
        
        console.log("---- entry-----");
        console.log(entry);
        return entry;
    }



    function buildHistory(localprops, selected)
    {
        var properties=JSON.parse(order.properties);
        var entry = buildHistoryEntry(selected);

        if (!(typeof properties === 'object') && (properties !== null)) properties={}; //initialize properties as object

        if (!properties.history) { properties.history=[]; }

        if (entry.changes.length>0) properties.history.push(entry);
        localprops.history=properties.history;
    }



    function handleSubmit(e) {
        e.preventDefault();

        let _orderid = 0;
        if (order) {
            _orderid = order.id;
        }

        let properties = JSON.parse(order.properties);
        properties.completion=completionList;

        let bodydata = JSON.stringify({
            action: action, session: session, id: _orderid, fieldid: fieldid, ownerid: order.ownerid, properties: JSON.stringify(properties)
        });
        
        
        fetch('https://online.mysoil.pl/cgi-bin/orders.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'
        })
            .then(res => res.json())
            .then(data => handleDataResponse(data))

    }

    function handleDataResponse(data) {

        if (data.status === "ok") {
            showAlert("green", data.message, 4000);
            props.Close(true); 
        }
        if (data.status !== "ok") {
            showAlert("red", data.message, 4000);
        }
    }



    function descriptionChange(e) {
        setDescription(e.target.value);
    }


    return (
        
        <div className='absolute w-full h-full top-0 left-0 items-center shadow-md justify-cener flex overflow-y-auto overflow-x-none'>
            <Card color="white" className="w-[20rem] mx-auto px-0 my-auto py-4 shadow-xl shrink h-auto z-5 overflow-x-none" shadow={true}>

                <div className="flex flex-row justify-between gap-2 w-auto my-2 ml-6">
                    <Typography variant="h6" color="blue-gray" >
                        {field.name}, Zlecenie  #{order.id}
                    </Typography>
                    <IconButton variant='text' className='top-[-1rem] right-2' color="blue-gray" data-refresh={false} onClick={cancelClose}>
                        <XMarkIcon className='w-6 h-6' />
                    </IconButton>
                </div>

                <div className="mb-2 mt-2 flex flex-row gap-3 w-full items-center justify-center">
                {field.image && <div className="mx-auto w-[200px] h-[160px] rounded-lg " ><img src={field.image} className='rounded-lg'></img></div>}
                </div>
                <form className="mt-2 mb-0 w-full items-center justify-center px-3 mx-0 " onSubmit={handleSubmit}>
                
                    <div className="mb-8 mt-6 flex flex-row gap-8 w-full items-center justify-center">

                        <Tooltip content="Jeszcze nie pobrano próbek">
                            <IconButton variant='gradient' className='' size='lg' color="red" data-refresh={false} onClick={() => onChangeCompletion(fieldid,0)} >
                                <StopIcon className='w-8 h-8' />
                            </IconButton>
                        </Tooltip>
                        
                        <Tooltip content="Pobrano część próbek">
                            <IconButton variant='gradient' className='' size='lg' color="orange" data-refresh={false} onClick={() => onChangeCompletion(fieldid,1)} >
                                <SquaresPlusIcon className='w-8 h-8' />
                            </IconButton>
                        </Tooltip>
                        
                        <Tooltip content="Pobrano wszystie próbki">
                            <IconButton variant='gradient' className='' size='lg' color="green" data-refresh={false} onClick={() => onChangeCompletion(fieldid,2)} >
                                <Squares2X2Icon className='w-8 h-8' />
                            </IconButton>
                        </Tooltip>
                        
                    </div>    

                        
                        

                        <div className='flex flex-row justify-between w-full mt-4 mb-0 items-center justify-center' >
                            <Button className="items-center  mx-auto w-32 justify-center bg-gradient-to-br from-teal-500 to-cyan-500 " data-refresh={true} fullWidth type="submit">
                                Zapisz
                            </Button>
                        </div>
                    

                </form>
            </Card>

        </div>
    );


}

